import React, { Component } from 'react';
import { Button, Stack, Paper, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import { post } from '../../util/api';
import { connect } from 'react-redux';
import { updateProfile } from '../../actions/access.actions';
import { Formik } from 'formik';
import {  FormikInputMUI } from '../../components/FormikInput';
import * as Yup from 'yup';
import _ from 'lodash';
import Company from './company';
import PersonIcon from '@mui/icons-material/Person';
import KeyIcon from '@mui/icons-material/Key';
import ApartmentIcon from '@mui/icons-material/Apartment';

function customizer(objValue, srcValue) {
	return _.isUndefined(objValue) || objValue === null ? srcValue : objValue;
}

var defaults = _.partialRight(_.assignWith, customizer);

const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: '#fff',
	boxShadow: 'none',
	...theme.typography.body2,
	padding: theme.spacing(1),
	textAlign: 'center',
	color: theme.palette.text.secondary,
}));

class UserPage extends Component {
	state = {
		userInfo: { icon: 'save', color: 'blue', saved: 'Save Changes', sending: false },
		userPassword: { icon: 'save', color: 'blue', saved: 'Save New Password', sending: false },
	};

	handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

	handleSubmit = (values) => {
		if (this.state.userInfo.sending) return;
		this.setState({ userInfo: { sending: true } });
		this.props.updateUser(values);
		this.setState({
			userInfo: { sending: false, errormessage: '', saved: 'Saved', color: 'teal', icon: 'check' },
		});
		clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			this.setState({ userInfo: { icon: 'save', color: 'blue', saved: 'Save' } });
		}, 2000);
		this.postData(values);
	};
	handleSubmitPassword = (values) => {
		if (this.state.userPassword.sending) return;
		this.setState({ userPassword: { sending: true } });
		this.props.updateUser(values);
		this.postPassword(values);
		if (this.state.passwordError) {
			this.setState({
				userPassword: { sending: false, errormessage: '', saved: 'Unsaved', color: 'red', icon: 'x' },
			});
		} else {
			this.setState({
				userPassword: { sending: false, errormessage: '', saved: 'Saved', color: 'teal', icon: 'check' },
			});
		}

		clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			this.setState({ userPassword: { icon: 'save', color: 'blue', saved: 'Save' } });
		}, 2000);
	};
	postData(values) {
		post('/auth/updateInfo', {
			name: values.name,
			phone: values.phone,
			company: values.company,
		});
	}
	postPassword(values) {
		post('/auth/updatePassword', {
			newpassword: values.newpassword,
		}).then((data) => {
			this.setState({ passwordErrorMessage: data.data.message, passwordError: data.data.success });
		});
	}
	render() {
		const initials = defaults({}, this.props.user, { name: '', company: '', phone: '' });

		let changePassword = this.props.user.extra && this.props.user.extra.isGoogle;
		console.log('Props', changePassword);
		return (
			<div>
				<Stack sx={{ marginBottom: '50px', marginTop: '20px' }}>
					<Divider textAlign="center" style={{ fontSize: '18px' }}>
						<PersonIcon sx={{ fontSize: '25px' }} />
						Personal Information
					</Divider>
					<Item sx={{ marginTop: '15px', backgroundColor: '#fff', boxShadow: 'none' }}>
						{/* <h3 style={{ marginBottom: '2rem', color: '#3f3f3f' }}>
							<Icon name="user" />
							Personal Information
						</h3> */}
						<Formik
							initialValues={initials}
							onSubmit={this.handleSubmit}
							validationSchema={Yup.object().shape({
								name: Yup.string().required('Name is required!'),
								company: Yup.string(),
								phone: Yup.string().matches(/^(\+)?[0-9]*$/, 'Phone number is not valid!'),
							})}
						>
							{(props) => {
								const { values, handleChange, handleBlur, handleSubmit } = props;
								return (
									<form onSubmit={handleSubmit} style={{ textAlign: 'left' }}>
										<FormikInputMUI
											fullWidth
											margin="normal"
											id="name"
											label="Name"
											name="name"
											icon="user"
											iconPosition="left"
											placeholder="Enter your name"
											type="text"
											value={values.name}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
										<FormikInputMUI
											fullWidth
											margin="normal"
											id="company"
											label="Company"
											icon="building"
											name="company"
											placeholder="Enter your company"
											iconPosition="left"
											type="text"
											value={values.company}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
										<FormikInputMUI
											fullWidth
											margin="normal"
											id="email"
											label="Email"
											name="email"
											icon="at"
											iconPosition="left"
											placeholder="Enter your email"
											type="text"
											value={values.email}
											onChange={handleChange}
											onBlur={handleBlur}
											InputProps={{
												readOnly: true,
											}}
										/>
										<FormikInputMUI
											fullWidth
											margin="normal"
											id="phone"
											label="Phone"
											iconPosition="left"
											name="phone"
											icon="phone"
											placeholder="Enter your phone"
											type="phone"
											value={values.phone}
											onChange={handleChange}
											onBlur={handleBlur}
										></FormikInputMUI>
										<Button
											type="submit"
											style={{ background: '#2185d0' }}
											fullWidth
											size="medium"
											variant="contained"
											sx={{
												marginTop: '15px',
												':hover': {
													color: '#fafafa',
													backgroundColor: 'rgb(0 102 178) !important',
												},
											}}
										>
											{this.state.userInfo.saved}
										</Button>
									</form>
								);
							}}
						</Formik>
					</Item>
				</Stack>
				{changePassword ? (
					<Stack sx={{ marginTop: '80px',marginBottom:'80px' }}>
					<Divider textAlign="center" style={{ fontSize: '18px' }}>
						{' '}
						<KeyIcon sx={{ fontSize: '25px' }} />
						You are logged in with Google, unfortunately you cannot change the password.
					</Divider>
					<Item sx={{ marginTop: '15px' }}>
						<Company />
					</Item>
				</Stack>
				) : (
					<Stack sx={{ marginBottom: '35px', marginTop: '75px' }}>
						<Divider textAlign="center" style={{ fontSize: '18px' }}>
							{' '}
							<KeyIcon sx={{ fontSize: '25px' }} />
							Password
						</Divider>
						<Item sx={{ marginTop: '15px' }}>
							{/* <h3 style={{ marginBottom: '2rem', color: '#3f3f3f' }}>
						<Icon name="lock" />
						Password
					</h3> */}
							<Formik
								onSubmit={this.handleSubmitPassword}
								validationSchema={Yup.object().shape({
									newpassword: Yup.string().required('Password is required!').min('6', 'Too Short, Must be 6 integer'),
									confirmpassword: Yup.string().oneOf([Yup.ref('newpassword'), null], 'Passwords must match'),
								})}
							>
								{(props) => {
									const { handleChange, handleBlur, handleSubmit } = props;
									return (
										<form onSubmit={handleSubmit} style={{ textAlign: 'left' }}>
											<FormikInputMUI
												fullWidth
												margin="normal"
												label="New Password"
												icon="key"
												iconPosition="left"
												name="newpassword"
												type="password"
												placeholder="Enter new password"
												id="newpassword"
												onChange={handleChange}
												onBlur={handleBlur}
											/>
											<FormikInputMUI
												fullWidth
												margin="normal"
												label="Confirm Password"
												icon="key"
												iconPosition="left"
												name="confirmpassword"
												type="password"
												placeholder="Enter new password again"
												onChange={handleChange}
												onBlur={handleBlur}
											/>
											<Button
												type="submit"
												fullWidth
												style={{ background: '#2185d0' }}
												size="medium"
												variant="contained"
												sx={{
													marginTop: '15px',
													':hover': {
														color: '#fafafa',
														backgroundColor: 'rgb(0 102 178) !important',
													},
												}}
											>
												{this.state.userPassword.saved}
											</Button>
										</form>
									);
								}}
							</Formik>
						</Item>
					</Stack>
				)}
				<Stack sx={{ marginTop: '80px' }}>
					<Divider textAlign="center" style={{ fontSize: '18px' }}>
						{' '}
						<ApartmentIcon sx={{ fontSize: '25px' }} />
						Company Information
					</Divider>
					<Item sx={{ marginTop: '15px' }}>
						<Company />
					</Item>
				</Stack>
			</div>
		);
	}
}

export default connect(
	(state) => ({ user: state.access.user.loggedUserObj }),
	(dispatch) => ({ updateUser: (user) => dispatch(updateProfile(user)) })
)(UserPage);
